module.exports = __webpack_public_path__ + "static/media/logomarca300px.7263dfc3.png";